import axios from 'axios';
import {Toast} from 'vant';
import Bus from '@/libs/bus';
import Config from '@/config';
import {getToken, setToken} from '@/libs/util';

const qs = require('qs');

class HttpRequest {
    constructor() {
        this.queue = {};
        this.baseUrl = process.env.NODE_ENV === 'development' ? Config.baseUrl.dev : Config.baseUrl.pro;
    }

    getInsideConfig() {
        return {
            timeout: 60000,
            baseURL: this.baseUrl,
            headers: {
                'Accept': 'application/json; charset=utf-8',
                'Content-type': 'application/json; charset=utf-8',
                'X-Client-Type': 'web',
                'X-Client-Version': Config.clientVersion,
                'X-Auth-Token': getToken()
            },
            paramsSerializer: function (params) {
                return qs.stringify(params, {arrayFormat: 'repeat'});
            }
        }
    }

    destroy(url) {
        delete this.queue[url];
    }

    interceptors(instance, url) {
        // 请求拦截
        instance.interceptors.request.use(config => {
            this.queue[url] = true;
            return config;
        }, error => {
            return Promise.reject(error);
        });

        // 响应拦截
        instance.interceptors.response.use(res => {
            this.destroy(url);
            const {data, status} = res;

            if (data.code === Config.successCode) {
                return {data, status};
            }

            Toast.fail(data.message);

            // 跳转到登录页
            let code = parseInt(data.code);
            if (code >= 301 && code <= 309) {
                setToken('');
                Bus.$emit('login');
            }

            return Promise.reject(new Error(data.message))
        }, error => {
            this.destroy(url);
            return Promise.reject(error);
        })
    }

    request(options) {
        const instance = axios.create();
        options = Object.assign(this.getInsideConfig(), options);
        this.interceptors(instance, options.url);
        return instance(options);
    }
}

export default new HttpRequest()
